module.exports = __webpack_public_path__ + "img/pic-s2-niezrownana-zwyciezczyni.png";